import { useEffect, useState } from "react";
import styles from "./MarketPlaceDetail.module.css";
import { CircularProgress, TextField } from "@mui/material";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import ArrayStepper from "../../../utils/Stepper/ArrayStepper";

const ReviewChat = ({ productId, vendorId }) => {
  const [trackingStatus, setTrackingStatus] = useState([]);
  const [threadData, setThreadData] = useState({});
  const [fetchLoader, setFetchLoader] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [replyValue, setReplyValue] = useState("");
  const [selectedThread, setSelectedThread] = useState("");
  const [selectedTicket, setSelectedTicket] = useState("");
  async function fetchData() {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/get_review_chat/${productId}/${vendorId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    );
    const m = await response.json();
    if (m.status === 200) {
      setTrackingStatus(m.tracking);
      setThreadData(m.data);
      setSelectedTicket(m.ticketId);
      return m;
    } else {
      throw new Error(m.msg);
    }
  }

  useEffect(() => {
    async function call() {
      setFetchLoader(true);
      await fetchData();
      setFetchLoader(false);
    }
    call();
    // eslint-disable-next-line
  }, [productId]);

  const handleReplySet = (value) => {
    setReplyValue(value);
  };

  const handleSendReply = async () => {
    try {
      setIsButtonLoading(true);
      if (replyValue.length !== 0) {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/sendReply`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              selectedTicket,
              selectedThread,
              replyValue,
              // The server resolves the recipient from this rather than
              // trusting an address from the browser — see sendReply.
              vendor_id: vendorId,
              sku_id: productId,
            }),
          },
        );
        const responseData = await response.json();
        if (responseData.status === 200) {
          await fetchData();
          setReplyValue("");
          setIsButtonLoading(false);
        } else {
          throw new Error(responseData.msg);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.reviewChat}>
      {fetchLoader && (
        <div className={styles.fetchLoader}>
          <CircularProgress size={25} />
        </div>
      )}
      {!fetchLoader && (
        <>
          <div className={styles.rightPanel}>
            <h5 className={styles.ticketTitle}>Ticket Details</h5>

            {threadData && (
              <div className={styles.stepperWrapper}>
                <div className={styles.stepperInner}>
                  <ArrayStepper trackingStatus={trackingStatus} />
                </div>
              </div>
            )}

            <div className={styles.chatContainer}>
              <ul className={styles.chatList}>
                {Array.isArray(threadData) &&
                  [...threadData].reverse().map((item) => (
                    <li key={item.id} className={styles.chatItem}>
                      <div
                        className={styles.chatContent}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    </li>
                  ))}
              </ul>

              <div className={styles.replyContainer}>
                <TextField
                  value={replyValue}
                  onChange={(e) => handleReplySet(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      setSelectedThread(threadData[0].id);
                      handleSendReply();
                    }
                  }}
                  fullWidth
                  label="Send a Message"
                />

                <div
                  className={styles.replyButton}
                  onClick={() => {
                    setSelectedThread(threadData[0].id);
                    handleSendReply();
                  }}
                >
                  {isButtonLoading ? (
                    <CircularProgress
                      size={20}
                      className={styles.loaderWhite}
                    />
                  ) : (
                    <div className={styles.replyButtonInner}>
                      <UTurnLeftIcon className={styles.replyIcon} />
                      <span>Reply</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewChat;
